import { Component, OnDestroy } from '@angular/core';

import { ReplaySubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import * as Roles from '../../core/roles';
import { SessionService } from '../../core/session.service';

interface DashboardTile {
  title: string;
  link: string;
  image: string;
}

@Component({
  selector: 'app-main-dashboard',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnDestroy {
  loading = true;
  cards = new ReplaySubject<DashboardTile[]>(1);
  subscription: Subscription;

  constructor(private session: SessionService) {
    this.subscription = this.session.permissions$
      .pipe(
        map((p) => {
          const tiles: DashboardTile[] = [];
          if (!!p.permissions[Roles.PERMISSIONS.dashboard_r]) {
            tiles.push({
              title: 'Métricas',
              link: './dashboard',
              image: 'assets/img/undraw_all_the_data.svg',
            });
          }
          if (!!p.permissions[Roles.PERMISSIONS.sick_note_r]) {
            tiles.push({
              title: 'Atestados',
              link: './documents/sick_notes/',
              image: 'assets/img/undraw_file_manager.svg',
            });
          }
          if (!!p.permissions[Roles.PERMISSIONS.ticket_r]) {
            tiles.push({
              title: 'Ações',
              link: './tickets',
              image: 'assets/img/undraw_light_the_fire.svg',
            });
          }
          return tiles;
        })
      )
      .subscribe((tiles) => {
        this.cards.next(tiles);
        this.loading = false;
      });
  }

  trackByLink(_index: number, tile: DashboardTile): string {
    return tile.link;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
